<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Counters",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Counters",
            items: [
               {
                  text: "Counters",
                  active: true,
               },                   
            ],

            
            counters: [],
            type : 2,
           
            status: '',
            keyword: "",
            listing_length: 10,
            token: "",
            pharmacy:{},
            errors: {},
            button_title: "Save",
            pagination: {},
            isEdit: false,
            modal_title: "Add Counter",

            form: {
                id: null,
                counter_name: '',
                username: '',
                password:'',
                priority_type: '',
                prefix: null,
                token_management_type: 2,
                scroll_up: 2,
            },

            change_password: {
                    password: '',
                    password_confirmation: '',
            },
            
            active_page_url: null,
            loading: false,
         };
      },
      mounted() {

      },

      created() {
         this.fetchCounters();
      },

      watch: {
         'form.priority_type'(newValue) {
            if (newValue == 3) {
               this.form.prefix = null;
            }
         }
      },

      methods: {


         fetchCounters(page_url = null){

            this.getToken();

            let url = "clinic/clinic/counters?limit=" + this.listing_length +
                        "&status=" + this.status +
                        "&keyword=" + this.keyword +
                        "&type=" + this.type +
                        "&pharmacy_id=" + this.$route.params.id;
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

         this.active_page_url = page_url;
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               this.pharmacy = responseData.details;
               this.counters = responseData.counters.data;
               this.from = responseData.counters.from;
               this.to = responseData.counters.to;
               this.total = responseData.counters.total;
               this.pagination = responseData.counters.links;



            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));





         },
         
          getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },



         formatDate(dateString) {
			const date = new Date(dateString);

			const day = date.getDate();
			const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
			const year = date.getFullYear();

			const hours = date.getHours();
			const minutes = date.getMinutes();

			return `${day} ${month} ${year}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
		},
         
       
       
         showModal(modal) {
            this.$refs[modal].show();
         },
         hideModal(modal) {
            this.$refs[modal].hide();
         },
        
        editCounter(counter) {
            this.modal_title = 'Edit Counter';
            this.button_title = 'Update';
            this.isEdit = true;
            this.form.id = counter.id || '';
            this.form.counter_name = counter.counter_name || '';
            this.form.username = counter.username || '';
            this.form.priority_type = counter.priority_type || '';
            this.form.prefix = counter.prefix || null;
            this.form.token_management_type = counter.token_management_type || 2;
            this.form.scroll_up = counter.scroll_up || 2;
            this.form.password = ''; 

            // Open modal
            this.$refs['counter-modal'].show();
        },

        addCounterModal() {
            this.modal_title = 'Add Counter';
            this.button_title = 'Save';
            this.isEdit = false;
            this.clearForm();
            this.$refs['counter-modal'].show();
        },

        addCounter(){

            this.getToken();

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            const url = this.isEdit
                ? 'clinic/clinic/updateCounter'  
                : 'clinic/clinic/addCounter';
                
            const payload = {
                counter_name: this.form.counter_name,
                username: this.form.username,
                type: this.type,
                priority_type: this.form.priority_type,
                token_management_type: this.form.token_management_type,
                scroll_up: this.form.scroll_up,
                pharmacy_id: this.$route.params.id,
                id  : this.form.id,
            };

            if (this.form.priority_type == 2 && this.form.prefix !== null && this.form.prefix !== '') {
                payload.prefix = this.form.prefix;
            } else if (this.form.priority_type == 3) {
                payload.prefix = "";
            }

            if (!this.isEdit) {
                payload.password = this.form.password;
            }
            this.loading = true;
            
            this.$axios
            .post(url, payload, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                     this.$refs['counter-modal'].hide();
                     this.fetchCounters(); 
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.hideModal('counter-modal');
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

   

         },

         updateTitle() {
               this.getToken();           
               
               const config = {
                  headers: {
                     "Content-type": "application/json",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
               };

               let formData = new FormData();
               formData.append("type", 2); 
               formData.append("pharmacy_id", this.$route.params.id); 
               formData.append("counter_title", this.pharmacy.counter_title); 
      
               let url = "clinic/clinic/updateCounterTitle";
               this.loading = true;
               
               this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('title-modal');
                  this.fetchCounters(this.active_page_url);
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        // console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

        counterDelete(counter) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to delete this counter account?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                     this.getToken();

                     const config = {
                        headers: {

                           "Accept": "application/json",
                           "Authorization": "Bearer " + this.token,
                        },
                     };

                     let url = "clinic/clinic/deleteCounter";
                     let formData = new FormData();
                     formData.append("counter_id", counter.id);

                     this.$axios
                        .post(url, formData, config)
                        .then((response) => {
                           if (response.data.status) {
                              this.$swal("", response.data.message, "success");
                           } else {
                              this.$swal("", response.data.message, "error");
                           }
                           this.fetchCounters();
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },

         changePassword(counter) {      
                this.change_password.id = counter.id;
                this.edit = true;
                this.showModal("password-modal");
         },

         updatePassword() {
                this.getToken();           
                
                const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
                };

                let url = "clinic/clinic/CounterChangePassword";
                this.active_page_url = null;
                let formData = new FormData();
                formData.append("counter_id", this.change_password.id); 
                formData.append("password", this.change_password.password); 
                formData.append("password_confirmation", this.change_password.password_confirmation); 
                
                this.loading = true;
            
                this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.hideModal('password-modal');
                    this.fetchCounters(this.active_page_url);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            this.errors = error.response.data.message;
                            //console.log(this.errors);
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
         }, 

          changeCounterStatus(counter_id, status){

            this.getToken();
            let url = "clinic/clinic/updateCounterStatus?counter_id=" + counter_id + "&status=" + status;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchCounters();
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
            this.fetchTvs();
        },


        clearForm() {
            this.form = {
            counter_name: '',
            username: '',
            priority_type: '',
            prefix: null,
            password: '',
            token_management_type: 2,
            scroll_up: 2,
            };
            this.errors = {};
            this.isEdit = false;

            this.change_password.password = "";
            this.change_password.password_confirmation = "";
        },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                      <h5>Update Normal Counter Display Name : {{ pharmacy.counter_title }} </h5>
                        <b-button v-b-modal.counter-modal variant="primary" class="float-end" @click="addCounterModal()">Add Counter</b-button>
                        <b-button v-b-modal.title-modal variant="primary" class="float-end me-2">Update Normal Counter Display Name</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change = "fetchCounters()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup = "fetchCounters()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change = "fetchCounters()">
                              <option value="">All</option>
                              <option value="1">Published</option>
                              <option value="2">Unpublished</option>
                           </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th width="10%">Counter Name</th>   
                              <th width="10%">User Name</th>
                              <th width="10%">Prefix</th>
                              <th width="10%">Priority</th>
                              <th width="15%">Token Management Type</th>
                              <th width="10%">Scroll Up</th>
                              <th width="10%">Created On</th>
                              <th width="10%">Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(counters.length)">
                           <tr v-for="counter in counters" :key="counter.id">
                              <td>{{ counter.counter_name }}</td>
                              <td>{{ counter.username }}</td>
                              <td>{{ counter.prefix || '-' }}</td>
                              <td>{{ counter.priority_type == 1 ? 'Yes' : counter.priority_type == 2 ? 'Yes' : 'No' }}</td>
                              <td>{{ counter.token_management_type == 3 ? 'OP outsource' : 'Current token tracking' }}</td>
                              <td>{{ counter.scroll_up == 1 ? 'Yes' : 'No' }}</td>
                              <td>{{ formatDate(counter.created_at) }}</td>
                              <td>
                                 <b-button variant="primary" v-b-modal.counter-modal class="btn btn-sm me-2 mb-2" @click="editCounter(counter)">Edit</b-button> 
                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                 v-if="counter.status == 1" @click="changeCounterStatus(counter.id, 2)" >Unpublish</b-button>
                                 <b-button variant="success" class="btn-sm me-2 mb-2"
                                 v-if="counter.status == 2" @click="changeCounterStatus(counter.id, 1)" >Publish</b-button>

                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                  @click="counterDelete(counter)" >Delete</b-button>
                                 <b-button variant="danger" class="btn-sm mb-2 me-2" @click="changePassword(counter)"><i class='bx bxs-key'></i></b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="8" class="text-center">No counters found</td>
                           </tr>
                        </tbody>

                  </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(counters.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchCounters(page.url + '&limit=' + listing_length + '&keyword=' + keyword + '&status=' + status + '&pharmacy_id=' + this.$route.params.id + '&type=2')">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                 
                <b-modal ref="counter-modal" id="counter-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                    <b-form @submit.prevent="addCounter">
                        <div class="row">

                         <!-- Priority Type -->
                        <div class="form-group col-md-6 mb-3">
                            <label class="control-label">Priority Type <span class="text-danger">*</span></label>
                            <select class="form-control" v-model="form.priority_type" :class="{ 'is-invalid': errors.priority_type }">
                            <option value="">Select</option>
                            <option value="2">Priority</option>
                            <option value="3">Normal</option>
                            </select>
                            <div class="invalid-feedback" v-if="errors.priority_type">
                            {{ errors.priority_type[0] }}
                            </div>
                        </div>

                        <!-- Prefix -->
                        <div class="form-group col-md-6 mb-3" v-if="form.priority_type == 2">
                            <label class="control-label">Prefix</label>
                            <input type="text" class="form-control" v-model="form.prefix" :class="{ 'is-invalid': errors.prefix }" />
                            <div class="invalid-feedback" v-if="errors.prefix">
                            {{ errors.prefix[0] }}
                            </div>
                        </div>

                        <!-- Token Management Type -->
                        <div class="form-group col-md-12 mb-3">
                            <label class="control-label">Token Management Type <span class="text-danger">*</span></label>
                            <b-form-radio-group
                                v-model="form.token_management_type"
                                name="pharmacyCounterTokenType"
                                :class="{ 'is-invalid': Boolean(errors.token_management_type) }"
                                inline
                            >
                                <div class="form-check-inline">
                                    <b-form-radio :value="2">Current token tracking</b-form-radio>
                                </div>
                                <div class="form-check-inline">
                                    <b-form-radio :value="3">OP outsource</b-form-radio>
                                </div>
                            </b-form-radio-group>
                            <div v-for="(val, index) in errors.token_management_type" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                            </div>
                        </div>

                        <!-- Scroll Up -->
                        <div class="form-group col-md-12 mb-3">
                            <b-form-checkbox v-model="form.scroll_up" :value="1" :unchecked-value="2">
                                Scroll Up
                            </b-form-checkbox>
                            <div v-for="(val, index) in errors.scroll_up" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                            </div>
                        </div>

                        <!-- Counter Name -->
                        <div class="form-group col-md-6 mb-3">
                            <label class="control-label">Counter Name <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="form.counter_name" :class="{ 'is-invalid': errors.counter_name }" />
                            <div class="invalid-feedback" v-if="errors.counter_name">
                            {{ errors.counter_name[0] }}
                            </div>
                        </div>

                        <!-- Username -->
                        <div class="form-group col-md-6 mb-3">
                            <label class="control-label">Username <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="form.username" :class="{ 'is-invalid': errors.username }" />
                            <div class="invalid-feedback" v-if="errors.username">
                            {{ errors.username[0] }}
                            </div>
                        </div>

                       
                        <!-- Password -->
                        <div class="form-group col-md-6 mb-3" v-if="!isEdit">
                            <label class="control-label">Password <span class="text-danger">*</span></label>
                            <input type="password" class="form-control" v-model="form.password" :class="{ 'is-invalid': errors.password }" />
                            <div class="invalid-feedback" v-if="errors.password">
                            {{ errors.password[0] }}
                            </div>
                        </div>
                        </div>

                        <!-- Buttons -->
                        <b-col md="12">
                           <div class="page-loader" v-if="!loading">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button variant="light" @click="hideModal('counter-modal')">Close</b-button>
                           </div>
                           <div class="page-loader" v-else>
                              <img src="@/assets/images/preloaderspin.gif"/>
                           </div>
                        </b-col>
                    </b-form>
                </b-modal>

                <!----- update password modal starts ---->
                    <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
                        <b-form @submit.prevent="updatePassword()">
                            <b-row>  
                            <b-col lg="12" class="form-group">
                                <label class="control-label">New Password<span class="text-danger">*</span></label>
                                <b-form-input type="password" v-model="change_password.password"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                                <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>  

                            <b-col lg="12" class="form-group">
                                <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                                <b-form-input type="password" v-model="change_password.password_confirmation"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>

                                <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                </div>
                            </b-col>    
                            
                            <b-col lg="12">
                               <div class="page-loader" v-if="!loading">
                                  <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
                               </div>
                               <div class="page-loader" v-else>
                                  <img src="@/assets/images/preloaderspin.gif"/>
                               </div>
                            </b-col>
                            </b-row>
                        </b-form>
                    </b-modal>
                    <!----- update password modal ends ---->
     <!---- modal starts ---->
                  <b-modal ref="title-modal" id="title-modal" title="Update Normal Counter Display Name" hide-footer @hidden="clearForm()">
                     <b-form  @submit.prevent="updateTitle()">                        
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                           <label class="control-label">Title<span class="text-danger">*</span></label>
                           <b-form-input v-model="pharmacy.counter_title"></b-form-input>
                        </b-col>

                           <b-col md="12" class="mt-3">
                              <div class="page-loader" v-if="!loading">
                                 <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                                 <b-button class="" variant="light" @click="hideModal('title-modal')">Close</b-button>
                              </div>
                              <div class="page-loader" v-else>
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
